export const backtesting = {
  pageTitle: "Backtesting Portfolio",
  eyebrow: "Test before you invest",
  subtitle:
    "Build up to three portfolios, choose a date range and see how they would have performed against the S&P 500 using dividend-adjusted historical prices.",
  builderTitle: "Build your portfolios",
  defaultPortfolioName: "Portfolio {{n}}",
  portfolioName: "Portfolio name",
  portfolioNamePlaceholder: "My portfolio",
  addStocks: "Add stocks",
  searchPlaceholder: "Search stocks (e.g., AAPL, MSFT)",
  noSearchResults: "No results found. Press Enter to add {{ticker}} directly.",
  allocations: "Allocations",
  equalWeight: "Equal weight",
  allocationFor: "Allocation for {{ticker}}",
  removeStock: "Remove {{ticker}}",
  total: "Total: {{total}}%",
  mustEqual100: "(must equal 100%)",
  sharedSettings: "Shared settings",
  startYear: "Start year",
  endYear: "End year",
  initialInvestment: "Initial investment ($)",
  run: "Run backtest",
  runWithCount: "Run backtest ({{count}})",
  running: "Running backtest…",
  fetching: "Fetching {{ticker}}… ({{completed}}/{{total}})",
  fetchingTicker: "Fetching {{ticker}}",
  maxPortfolios: "Maximum {{max}} portfolios allowed",
  minPortfolios: "At least one portfolio is required",
  duplicateTicker: "{{ticker}} is already in this portfolio",
  noValidPortfolio: "Add at least one valid portfolio (with stocks totaling 100%)",
  skippedTickers:
    "Could not fetch data for: {{tickers}}. Running backtest with remaining stocks.",
  complete: "Backtest complete. Portfolios tested: {{count}}",
  resultRemoved: "Strategy removed from comparison",
  errors: {
    noData: "Failed to fetch data for all stocks. Please try again.",
    noOverlap: "Insufficient overlapping data for selected stocks and date range",
    timeout: "Backtest timed out after 30 seconds. Please try again.",
    generic: "Failed to run backtest",
  },
  emptyTitle: "No backtests yet",
  emptyBody:
    "Build a portfolio by adding stocks, setting allocations, and choosing a date range. Then run a backtest to see how it would have performed.",
  metricsTitle: "Portfolio metrics",
  finalValue: "Final value",
  startedAt: "Started at {{amount}}",
  totalReturn: "Total return",
  annualizedReturn: "Annualized return",
  cagr: "CAGR",
  maxDrawdown: "Max drawdown",
  largestDrop: "Largest drop",
  growthTitle: "Portfolio growth",
  drawdownTitle: "Drawdown",
  benchmark: "S&P 500",
  annualReturnsTitle: "Annual returns",
  year: "Year",
  start: "Start",
  end: "End",
  return: "Return",
  maxDd: "Max DD",
  best: "Best",
  worst: "Worst",
  positiveYears: "Positive years",
  positiveYearsValue: "{{positive}} of {{total}}",
  avgAnnualReturn: "Avg annual return",
  bestYear: "Best year",
  worstYear: "Worst year",
  comparisonTitle: "Strategy comparison",
  metric: "Metric",
  vsBenchmark: "vs S&P 500",
  volatility: "Volatility",
  sharpeRatio: "Sharpe ratio",
  removeResult: "Remove {{name}} from comparison",
  export: {
    button: "Export",
    csv: "Export as CSV",
    pdf: "Export as PDF",
    csvSuccess: "CSV exported successfully",
    csvError: "Failed to export CSV",
    pdfSuccess: "PDF exported successfully",
    pdfError: "Failed to export PDF",
    title: "Portfolio Backtest Results",
    generatedOn: "Generated on",
    summary: "Portfolio Summary",
    holdings: "Holdings",
    monthlyValues: "Monthly Values",
    portfolio: "Portfolio",
    initial: "Initial",
    initialInvestment: "Initial Investment",
    totalReturnPercent: "Total Return %",
    ticker: "Ticker",
    allocation: "Allocation",
    allocationPercent: "Allocation %",
    date: "Date",
  },
  disclaimer:
    "For education only — not investment advice. Results use month-end dividend-adjusted prices; each portfolio is bought once at the start and never rebalanced. Taxes and fees are not included. Past performance does not guarantee future results.",
} as const;
